import {
  AfterViewInit,
  Component, DestroyRef, ElementRef,
  EventEmitter, inject,
  Input, OnDestroy,
  OnInit,
  Output,
  Renderer2, ViewChild,
} from '@angular/core';
import {Subject, Subscription} from 'rxjs';
import {environment} from "../../../environments/environment";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

declare global {
  interface Window {
    smartCaptchaInit: () => void;
    smartCaptcha: any;
  }
}

@Component({
  selector: 'hidden-captcha',
  standalone: true,
  templateUrl: './hidden-captcha.component.html',
  styleUrls: ['./hidden-captcha.component.scss'],
})
export class HiddenCaptchaComponent implements OnInit, AfterViewInit, OnDestroy {
  @Output() captcha = new EventEmitter<string>();
  @Input() relodCaptchaTrigger: Subject<void> = new Subject<void>();
  @ViewChild('captchaContainer') captchaContainer!: ElementRef;

  private sitekey = environment.captcha;
  private widgetId: number | null = null;
  private reloadSub!: Subscription;
  private destroy = inject(DestroyRef)

  constructor(private renderer: Renderer2) {}

  ngOnInit(): void {
    if (!(window as any).smartCaptchaScriptLoaded) {
      const script = this.renderer.createElement('script');
      script.src = 'https://smartcaptcha.yandexcloud.net/captcha.js?render=explicit';
      script.async = true;
      script.defer = true;
      this.renderer.appendChild(document.body, script);
      (window as any).smartCaptchaScriptLoaded = true;
    }
  }

  ngAfterViewInit(): void {
    const checkReady = setInterval(() => {
      if ((window as any).smartCaptcha) {
        clearInterval(checkReady);
        this.renderCaptcha();
      }
    }, 100);

    this.reloadSub = this.relodCaptchaTrigger.asObservable()
      .pipe(takeUntilDestroyed(this.destroy))
      .subscribe(() => {
      this.executeCaptcha();
    });
  }

  ngOnDestroy(): void {
    this.reloadSub?.unsubscribe();
    if ((window as any).smartCaptcha && this.widgetId !== null) {
      (window as any).smartCaptcha.reset(this.widgetId);
    }
  }

  private renderCaptcha(): void {
    if (!this.captchaContainer) {
      console.error('Captcha container element not found!');
      return;
    }
    this.widgetId = (window as any).smartCaptcha.render(this.captchaContainer.nativeElement.id, {
      sitekey: this.sitekey,
      callback: (token: string) => this.captcha.emit(token),
      invisible: true,
    });
  }

  private executeCaptcha(): void {
    const sc = (window as any).smartCaptcha;
    if (sc && this.widgetId !== null) {
      sc.reset(this.widgetId);
      sc.execute(this.widgetId);
    }
  }

}
